









































import {Component, Prop, Ref, Vue} from 'vue-property-decorator'
import QuestionnaireService, {PMStrategyMini, Questionnaire} from '@/domain/Questionnaire'
import BusinessCondition from '@/domain/BusinessCondition'
import QuestionnaireGrid, {StrategyItem} from '@/components/QuestionnaireGrid.vue'
import Dialog from '@/components/Dialog.vue'
import Const from '@/util/Const'
import Indicator from '@/components/Indicator.vue'
import {State} from '@/views/diagnosis/Index.vue'

@Component({
  components: {QuestionnaireGrid, Dialog, Indicator},
})
export default class Q2 extends Vue {
  @Prop({type: Object, required: true})
  public state!: State

  @Ref() public qg!: QuestionnaireGrid
  public questionnaire: Questionnaire | null = null
  public bc: BusinessCondition | undefined = undefined
  private selectedItem: StrategyItem = {strategy: undefined}
  private con = Const

  public async created() {
    const q1 = this.state.q1
    if (!q1) {
      await this.$router.push('./')
      return
    }
    this.bc = BusinessCondition.find(q1)
    this.questionnaire = await QuestionnaireService.question(q1)

    // @ts-ignore
    this.$refs.indicator.change(1, true)
  }

  public back() {
    this.$router.push({path: './q1', query: {...this.state}})
  }

  public next() {
    const strategy = this.selectedItem.strategy as PMStrategyMini
    this.$emit('setState', {pms: strategy.code})

    const backUrl = this.state.backurl
    if (backUrl) {
      window.location.href = backUrl + (backUrl.indexOf('?') >= 0 ? '&' : '?') + 'pms=' + this.state.pms
    } else {
      this.$router.push({path: './result', query: {...this.state}})
    }
  }

  private onSelectStrategy(candidates: PMStrategyMini) {
    this.qg.select(candidates)
  }

  private selectStrategy(item: StrategyItem) {
    this.selectedItem = item

    // @ts-ignore
    this.$refs.indicator.change(2, false)
  }
}
